const productosRenderer = vm => (data, type, row) => {
    const m = new Map();

    (row.productos || []).forEach(p => {
        const k = p._id;
        if (!m.has(k)) m.set(k, { ...p });
        else m.get(k).cantidad += p.cantidad;
    });

    const parts = [];

    for (const p of m.values()) {
        const cant = vm.GLOBAL.FORMATO_NUMBER(p.cantidad);
        const unidad = `<span class='font11'>${p.unidad_codigo}</span>`;
        let line = `[${cant}${unidad}] `;

        if (vm.GLOBAL.COUNTRY === "MX" && p._id === 1) {
            const m3 = vm.GLOBAL.FORMATO_NUMBER(
                p.cantidad / vm.person.parametros.factor_m3
            );

            line += `[${m3}<span class='font11'>m3</span>] `;
        }

        line += `${p.producto_nombre}<br/>`;

        parts.push(line);
    }

    return parts.join("");
};

export default productosRenderer;